import {Injectable} from '@angular/core'
import {BehaviorSubject} from 'rxjs'
import {SessionStorageService} from '../../../storage/session-storage.service'
import {Tab} from '../../../../shared/components/domain/platform-search/platform-search.types'

@Injectable({
  providedIn: 'root',
})
export class LayoutSearchService {
  private readonly _showSearchPopup$ = new BehaviorSubject(false)

  constructor(private readonly storageService: SessionStorageService) {}

  get showSearchPopup$() {
    return this._showSearchPopup$.asObservable()
  }

  showSearchPopup() {
    this._showSearchPopup$.next(true)
  }

  hideSearchPopup() {
    this._showSearchPopup$.next(false)
  }

  openedFromSearch(): SearchType | undefined {
    return this.storageService.getObject(OPENED_FROM_SEARCH)
  }

  setOpenedFromSearch(value: SearchType) {
    this.storageService.setObject(OPENED_FROM_SEARCH, value)
  }

  clearOpenedFromSearch() {
    this.storageService.removeItem(OPENED_FROM_SEARCH)
  }
}

const OPENED_FROM_SEARCH = 'bgo.opened-from-search'
type SearchType = {searchText?: string; tab?: Tab}
